var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "75px",
    height: "76px",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(255, 255, 255)",
    d: "M31.723,75.158 L53.265,23.970 L74.806,75.158 L31.723,75.158 ZM0.208,75.158 L31.301,0.586 L44.560,32.383 L26.559,75.158 L0.208,75.158 Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo_white.39a34839134e4403a0f7aa6fbc3696aa.svg";